export default "__VITE_ASSET__D0eD3O7H__"